import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Tone from "../../reactronica/lib/tone";

type ReturnType = {
  isPlaying: boolean;
  bpm: number;
  volume: number;
  recorder: React.MutableRefObject<any>;
  exporting: boolean;
  handleVolumeChange: (_event: Event, newValue: number | number[]) => void;
  handlePlayStop: () => void;
  handleIncrementBpm: () => void;
  handleDecrementBpm: () => void;
  handleIncrementVolume: () => void;
  handleDecrementVolume: () => void;
  handleExport: () => void;
};

export const useDawControls = (): ReturnType => {
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [bpm, setBpm] = useState<number>(75);
  const [volume, setVolume] = useState<number>(5);
  const [exporting, setExporting] = useState<boolean>(false);
  const navigate = useRef(useNavigate());

  const recorder = useRef(new Tone.Recorder());

  const handleVolumeChange = (_event: Event, newValue: number | number[]) => {
    setVolume(Math.round(newValue as number));
  };

  const handleIncrementVolume = () => {
    if (volume < 100) setVolume((prev) => Math.round(prev + 1));
  };

  const handleDecrementVolume = () => {
    if (volume > 0) setVolume((prev) => Math.round(prev - 1));
  };

  const handlePlayStop = (): void => {
    if (!exporting) {
      setIsPlaying(!isPlaying);
    } else {
      alert("Cannot play song while it is being exported");
    }
  };

  const handleIncrementBpm = () => {
    setBpm(bpm + 1);
  };

  const handleDecrementBpm = () => {
    setBpm(bpm - 1);
  };

  const handleExport = (): void => {
    if (!isPlaying) {
      setExporting(!exporting);
    } else {
      alert("Cannot export while song is playing");
    }
  };

  useEffect(() => {
    if (exporting) {
      recorder.current.start();
    } else if (recorder.current.state === "started") {
      setTimeout(async () => {
        const recording = await recorder.current.stop();
        navigate.current("/mint", {
          state: { dawExportedBlob: recording },
        });
      }, 10);
    }
  }, [exporting]);

  return {
    isPlaying,
    bpm,
    volume,
    recorder,
    exporting,
    handleVolumeChange,
    handlePlayStop,
    handleIncrementBpm,
    handleDecrementBpm,
    handleIncrementVolume,
    handleDecrementVolume,
    handleExport,
  };
};
